import { useMemo, useState } from 'react';
import { capitalize } from '@mui/material';
import { get } from 'lodash';
import { observer } from 'mobx-react-lite';
import { ListPage, ListRow } from '/src/components';
import { useLenderStore } from '/src/context';
import { DataModelType } from '/src/lib/types';
import * as utils from '/src/utils';

/**
 * List Lenders Page
 */
export const ListLendersPage = observer(() => {
  const defaultSortType = 'name';
  const defaultSortReverse = false;

  /** Context **/
  const lenderStore = useLenderStore();

  /** State **/
  const [sortType, setSortType] = useState(defaultSortType);
  const [sortReverse, setSortReverse] = useState(defaultSortReverse);

  /** Computed **/
  const lenders = lenderStore.lenders;

  const listData = useMemo(() => {
    if (lenders) {
      const list = lenders.toSorted((a, b) => (get(a, sortType) > get(b, sortType) ? 1 : -1));
      if (sortReverse) list.reverse();

      return list;
    }
  }, [lenders, sortType, sortReverse]);

  /** Methods **/

  const sortList = (type?: string) => {
    if (type) {
      if (sortType === type) setSortReverse(!sortReverse);
      else setSortType(type);
    }
  };

  /** Render **/
  return (
    <ListPage
      data={listData}
      modelType={DataModelType.Lender}
      createUrl={'/companies/create'}
      headerItems={[
        { flex: 1, propName: 'name', label: 'Name' },
        { flex: 1, propName: 'loansParticipatedIn', label: 'Deals Participated In', type: 'number' },
        { flex: 1, propName: 'currentBalance', label: 'Current Total Balance' },
        { flex: 1, propName: 'status', label: 'Investor Status' },
      ]}
      sortType={sortType}
      sortReverse={sortReverse}
      sortList={sortList}
    >
      {listData?.map((lender, i) => (
        <ListRow
          key={lender._id}
          items={[
            { propName: 'name', content: lender.name, url: `/investors/${lender._id}` },
            { propName: 'loansParticipatedIn', content: lender.loansParticipatedIn },
            { propName: 'currentBalance', content: utils.currency.format(lender.currentBalance) },
            { propName: 'status', content: capitalize(lender.status) },
          ]}
          rowIndex={i}
        />
      ))}
    </ListPage>
  );
});
